import { Link } from 'react-router-dom';
import { specials } from '@/mocks/specials';

export default function SpecialFeature() {
  const items = specials.slice(0, 2);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 animate-fade-up md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-600">
            <i className="ri-gallery-view-2"></i>
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950">专题精选</h2>
        </div>
        <Link to="/special" className="text-xs font-medium text-primary-600 hover:text-primary-700">
          全部专题
        </Link>
      </div>
      <div className="flex flex-col gap-3">
        {items.map((special) => (
          <Link
            key={special.id}
            to={`/special/${special.id}`}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-100"
          >
            <div className="relative h-32 w-full overflow-hidden bg-background-200">
              <img
                src={special.cover}
                alt={`${special.title} 专题封面`}
                title={`${special.title} 专题合集`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-2 left-3 right-3">
                <h3 className="text-sm font-bold text-white group-hover:text-primary-200">{special.title}</h3>
                <p className="text-[11px] text-white/80">{special.subtitle}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}